import { useRedirectLogOutUser } from "../../customHook/useRedirectLogOutUser"
import { createCategory, getallCategories, deleteCategory, getSingleCategory, updateCategory, activateCategory } from "../../redux/features/product/categorySlice"
import { getallAttributes } from "../../redux/features/product/attributeSlice"
import { useState, useMemo, useEffect } from "react"
import { toast } from "react-toastify"
import { useDispatch, useSelector } from "react-redux"
import ButtonLoading from "../../loader/ButtonLoader"
import { useTable, usePagination, useGlobalFilter, useFilters } from 'react-table';
import { GlobalFilter } from '../globalFilter';
import { MdDeleteForever, MdEditSquare } from "react-icons/md";
import { AiOutlinePlus } from "react-icons/ai";
import React, { useRef } from "react";
import ReactToPrint from "react-to-print";
import { CategoryPrint } from "./print/CategoryPrint";
import { SelectColumnFilter, multiSelectFilter } from "./dashBoard/SelectColumnFilter1"
import { Modal } from "bootstrap";
import { ColumnToggle } from "./ColumnToggle"
import { VscLayersActive } from "react-icons/vsc"

class ComponentToPrint extends React.Component {
  render() {
    return (
      <div className='printOnly'>
        <CategoryPrint Categories={this.props.Categories} />
      </div>
    )
  }
}

const initialState = {
  name: "",
  attributes: [],
  measurementUnit: "pcs"
}

export const Category = () => {
  useRedirectLogOutUser();

  const dispatch = useDispatch();
  const componentRef = useRef();
  const editModalRef = useRef(null);
  const deleteModalRef = useRef(null);
  const addModalRef = useRef(null);
  const attributeDropdownRef = useRef(null);
  const activateModalRef = useRef(null);

  const [categoryForm, setCategoryForm] = useState(initialState);
  const [isLoading, setIsLoading] = useState(false);
  const [printView, setPrintView] = useState(false);
  const [editId, setEditId] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [attributeDropdownOpen, setAttributeDropdownOpen] = useState(false);
  const [activateId, setActivateId] = useState(null);

  const { name } = categoryForm;

  const { categories, category } = useSelector((state) => state.category);
  const { attributes: allAttributes } = useSelector((state) => state.attribute);
  const { userType } = useSelector((state) => state.auth);
  const isAdmin = userType === "admin";

  // ─── Fetch on mount ─────────────────────────────────────────
  useEffect(() => {
    dispatch(getallCategories());
    dispatch(getallAttributes());
  }, [dispatch]);

  // ─── Populate edit form ──────────────────────────────────────
  useEffect(() => {
    if (category && editId) {
      setCategoryForm({
        name:            category.name            || "",
        measurementUnit: category.measurementUnit || "pcs",
        attributes:      category.attributes?.map(a => a._id || a) || [],
      });
    }
  }, [category, editId]);

  // ─── Close attribute dropdown on outside click ───────────────
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (attributeDropdownRef.current && !attributeDropdownRef.current.contains(e.target)) {
        setAttributeDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // ─── Modal openers ───────────────────────────────────────────
  const openAddModal = () => {
    setCategoryForm(initialState);
    setAttributeDropdownOpen(false);
    document.activeElement?.blur();
    new Modal(addModalRef.current).show();
  };

  const openEditModal = (id) => {
    setCategoryForm(initialState);
    setEditId(id);
    setAttributeDropdownOpen(false);
    dispatch(getSingleCategory(id));
    document.activeElement?.blur();
    new Modal(editModalRef.current).show();
  };

  const openDeleteModal = (id) => {
    setDeleteId(id);
    document.activeElement?.blur();
    new Modal(deleteModalRef.current).show();
  };

  const openActivateModal = (id) => {
    setActivateId(id);
    document.activeElement?.blur();
    new Modal(activateModalRef.current).show();
  };

  // ─── Input handlers ──────────────────────────────────────────
  const handleChange = (e) => {
    setCategoryForm({ ...categoryForm, [e.target.name]: e.target.value });
  };

  const handleActivateCategory = async () => {
    await dispatch(activateCategory(activateId));
    dispatch(getallCategories());
    Modal.getInstance(activateModalRef.current).hide();
  }

  const handleAttributeToggle = (attrId) => {
    const current = categoryForm.attributes;
    const updated = current.includes(attrId)
      ? current.filter(id => id !== attrId)
      : [...current, attrId];
    setCategoryForm({ ...categoryForm, attributes: updated });
  };

  // ─── Print ───────────────────────────────────────────────────
  const handlePrint = () => setPrintView(true);
  const handleBeforeGetContent = async () => await setPrintView(true);

  // ─── Shared form fields ──────────────────────────────────────
  const renderFormFields = () => (
    <div className="row g-3">

      {/* Category Name */}
      <div className="col-12">
        <label className="h4">Category Name</label>
        <input
          type="text"
          className="form-control form-control-lg border-2"
          name="name"
          value={categoryForm.name}
          onChange={handleChange}
          placeholder="Enter category name"
        />
      </div>

      {/* Measurement Unit */}
      <div className="col-12">
        <label className="h4">Measurement Unit</label>
        <select
          className="form-select form-select-lg border-2 fs-4"
          name="measurementUnit"
          value={categoryForm?.measurementUnit}
          onChange={handleChange}
        >
          <option value="pcs">Pcs</option>
          <option value="m2">m² (Square Meter)</option>
          <option value="linear_meter">Linear Meter</option>
          <option value="box">Box</option>
          <option value="kg">Kg</option>
        </select>
      </div>

      {/* Attributes dropdown with checkboxes */}
      <div className="col-12">
  <label className="h4">Attributes</label>
  <div className="d-flex flex-wrap gap-2 p-3 bg-white border rounded-3"
    style={{ minHeight: "60px" }}>
    {(!allAttributes || allAttributes.length === 0) && (
      <p className="text-muted mb-0" style={{ fontSize: "1.25rem" }}>
        No attributes found.
      </p>
    )}
    {allAttributes?.map((attr) => {
      const selected = categoryForm.attributes.includes(attr._id);
      return (
        <span
  key={attr._id}
  className={`badge rounded-pill px-3 py-2 fs-4 fw-medium ${
    selected
      ? 'bg-primary text-white'
      : 'bg-light text-dark border'
  }`}
  style={{ cursor: "pointer", userSelect: "none", lineHeight: "1.5" }}
  onClick={() => handleAttributeToggle(attr._id)}
>
  {selected && <span className="me-1">✓</span>}
  {attr.name}
</span>
      );
    })}
  </div>
  {categoryForm.attributes.length > 0 && (
    <small className="text-muted mt-1 d-block fs-5">
      {categoryForm.attributes.length} attribute{categoryForm.attributes.length > 1 ? 's' : ''} selected
    </small>
  )}
</div>

    </div>
  );

  // ─── Table columns ───────────────────────────────────────────
  const columns = useMemo(() => {
    const baseColumns = [
      {
        Header: 'No',
        accessor: 'no',
        Cell: ({ row }) => row.index + 1
      },
      {
        Header: 'Category',
        accessor: 'name',
        Filter: SelectColumnFilter,
        filter: 'multiSelectFilter'
      },
      {
        Header: 'Unit',
        accessor: 'measurementUnit',
        Filter: SelectColumnFilter,
        filter: 'multiSelectFilter',
      },
      {
        Header: 'Attributes',
        accessor: 'attributes',
        Cell: ({ value }) => (
          <div className="d-flex flex-wrap gap-1">
            {value?.map((attr, i) => (
              <span
                key={i}
                className="badge bg-primary bg-opacity-10 text-primary rounded-pill px-2 py-1 fs-6"              >
                {attr.name || attr}
              </span>
            ))}
          </div>
        )
      },
      {
        Header: "Is Active",
        accessor: "isActive",
        Cell: ({ value }) => (
          <span className={`badge ${value ? 'bg-success' : 'bg-danger'} bg-opacity-10 text-${value ? 'success' : 'danger'} rounded-pill px-2 py-1 fs-6`}>
            {value ? 'Active' : 'Inactive'}
          </span>
        ),
      },
    ];

    if (!printView && isAdmin) {
      baseColumns.push({
        Header: 'Action',
        Cell: ({ row }) => (
          <>
            <span
              className="text-warning"
              style={{ padding: '5px', cursor: 'pointer' }}
              onClick={() => openEditModal(row.original._id)}
            >
              <MdEditSquare size={24} />
            </span>
            {row.original.isActive ? (
            <span
              className="text-danger"
              style={{ padding: '5px', cursor: 'pointer' }}
              onClick={() => openDeleteModal(row.original._id)}
            >
              <MdDeleteForever size={24} />
            </span>
            ) : (
              <span
                className="text-success"
                style={{ padding: '5px', cursor: 'pointer' }}
                onClick={() => openActivateModal(row.original._id)}
              >
                <VscLayersActive size={24} />
              </span>
            )}
          </>
        )
      });
    }

    return baseColumns;
  }, [printView]);

  const data = useMemo(() => categories, [categories]);
  const filterTypes = useMemo(() => ({ multiSelectFilter }), []);

  const tableInstance = useTable({
    columns,
    data,
    filterTypes,
    defaultColumn: { Filter: () => null }
  }, useFilters, useGlobalFilter, usePagination);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    gotoPage,
    pageCount,
    setGlobalFilter,
    pageOptions,
    setPageSize,
    state,
    prepareRow,
    rows,
    setAllFilters,
    allColumns,
    getToggleHideAllColumnsProps
  } = tableInstance;

  const { pageIndex, globalFilter, pageSize } = state;

  return (
    <div>

      {/* ── ADD MODAL ─────────────────────────────────────────── */}
      <div className="modal fade" ref={addModalRef} tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
          <div className="modal-content border-0 rounded-4 shadow-lg p-3">

            <div className="modal-header pb-3">
              <div className="d-flex align-items-center gap-3">
                <div
                  className="d-flex align-items-center justify-content-center rounded-circle"
                  style={{ width: 48, height: 48, backgroundColor: "#e7f1ff" }}
                >
                  <AiOutlinePlus color="#0d6efd" size={28} />
                </div>
                <div>
                  <h3 className="modal-title fw-semibold mb-1">Add Category</h3>
                  <small className="text-muted fs-5">Create a new category.</small>
                </div>
              </div>
              <button className="btn-close ms-auto" data-bs-dismiss="modal" />
            </div>

            <form
              onSubmit={async (e) => {
                e.preventDefault();
                if (!categoryForm.name) return toast.error("Please fill in the category name");
                setIsLoading(true);
                await dispatch(createCategory({
                  name:            categoryForm.name,
                  attributes:      categoryForm.attributes,
                  measurementUnit: categoryForm.measurementUnit,
                }));
                setIsLoading(false);
                Modal.getInstance(addModalRef.current).hide();
                setCategoryForm(initialState);
              }}
              className="border-0"
            >
              <div className="modal-body border-0 py-3">
                <div className="bg-light rounded-3 px-3 py-3">
                  {renderFormFields()}
                </div>
              </div>
              <div className="modal-footer border-0 pt-0 gap-2">
                <button
                  type="button"
                  className="btn btn-danger border flex-fill rounded-3 fw-medium py-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                {isLoading ? (
                  <ButtonLoading
                    className="btn btn-primary flex-fill rounded-3 fw-medium py-2"
                    disabled
                  >
                    Loading...
                  </ButtonLoading>
                ) : (
                  <button className="btn btn-primary flex-fill rounded-3 fw-medium py-2">
                    Add
                  </button>
                )}
              </div>
            </form>

          </div>
        </div>
      </div>

      {/* ── EDIT MODAL ────────────────────────────────────────── */}
      <div className="modal fade" ref={editModalRef} tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
          <div className="modal-content border-0 rounded-4 shadow-lg p-3">

            <div className="modal-header pb-3">
              <div className="d-flex align-items-center gap-3">
                <div
                  className="d-flex align-items-center justify-content-center rounded-circle"
                  style={{ width: 48, height: 48, backgroundColor: "#e7f1ff" }}
                >
                  <MdEditSquare color="#0d6efd" size={28} />
                </div>
                <div>
                  <h3 className="modal-title fw-semibold mb-1">Edit Category</h3>
                  <small className="text-muted fs-5">Update category information.</small>
                </div>
              </div>
              <button className="btn-close ms-auto" data-bs-dismiss="modal" />
            </div>

            <form
              onSubmit={async (e) => {
                e.preventDefault();
                await dispatch(updateCategory({
                  id: editId,
                  data: {
                    name:            categoryForm.name,
                    attributes:      categoryForm.attributes,
                    measurementUnit: categoryForm.measurementUnit,
                  }
                }));
                dispatch(getallCategories());
                Modal.getInstance(editModalRef.current).hide();
              }}
              className="border-0"
            >
              <div className="modal-body py-3">
                <div className="bg-light rounded-3 px-3 py-3">
                  {renderFormFields()}
                </div>
              </div>
              <div className="modal-footer border-0 pt-0 gap-2">
                <button
                  type="button"
                  className="btn btn-danger border flex-fill rounded-3 fw-medium py-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button className="btn btn-primary flex-fill rounded-3 fw-medium py-2">
                  Update
                </button>
              </div>
            </form>

          </div>
        </div>
      </div>

      {/* ── DELETE MODAL ──────────────────────────────────────── */}
      <div className="modal fade" ref={deleteModalRef} tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content border-0 rounded-4 shadow-lg p-3">

            <div className="modal-header border-0 pb-0">
              <div className="d-flex align-items-center gap-3">
                <div
                  className="d-flex align-items-center justify-content-center rounded-circle"
                  style={{ width: 48, height: 48, backgroundColor: "#fde2e2" }}
                >
                  <MdDeleteForever color="red" size={40} />
                </div>
                <div>
                  <h3 className="modal-title fw-semibold mb-1">Delete Category</h3>
                  <small className="text-muted fs-5">This action cannot be undone.</small>
                </div>
              </div>
              <button className="btn-close ms-auto" data-bs-dismiss="modal" />
            </div>

            <div className="modal-body py-3">
              <div className="bg-light rounded-3 px-3 py-3">
                <p className="mb-0">
                  Are you sure you want to delete this category? All associated
                  data will be permanently removed from your workspace.
                </p>
              </div>
            </div>

            <div className="modal-footer border-0 pt-0 gap-2">
              <button
                className="btn btn-primary border flex-fill rounded-3 fw-medium py-2"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                className="btn btn-danger flex-fill rounded-3 fw-medium py-2"
                onClick={() => {
                  dispatch(deleteCategory(deleteId));
                  Modal.getInstance(deleteModalRef.current).hide();
                }}
              >
                <i className="bi bi-trash3 me-2"></i>
                Delete
              </button>
            </div>

          </div>
        </div>
      </div>

      {/* Activate Modal */}
        <div className="modal fade" ref={activateModalRef} tabIndex="-1" data-bs-focus="false">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content border-0 rounded-4 shadow-lg p-3">
            <div className="modal-header border-0 pb-0">
              <div className="d-flex align-items-center gap-3">
                <div
                  className="d-flex align-items-center justify-content-center rounded-circle"
                  style={{ width: 48, height: 48, backgroundColor: "#fde2e2" }}
                >
                  <VscLayersActive color="green" size={40} />
                </div>
                <div>
                  <h3 className="modal-title fw-semibold mb-1">Activate Category</h3>
                  <small className="text-muted fs-5">
                    Activating this category will make it available for use again.
                  </small>
                </div>
              </div>
              <button className="btn-close ms-auto" data-bs-dismiss="modal" />
            </div>

            <div className="modal-body py-3">
              <div className="bg-light rounded-3 px-3 py-3">
                <p className="mb-0 h-3">
                  Are you sure you want to activate this category? It will be made available for use again.
                </p>
              </div>
            </div>

            <div className="modal-footer border-0 pt-0 gap-2">
              <button
                className="btn btn-primary border flex-fill rounded-3 fw-medium py-2"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>

              <button
                className="btn btn-success flex-fill rounded-3 fw-medium py-2"
                onClick={handleActivateCategory}
              >
                Activate
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* ── TABLE ─────────────────────────────────────────────── */}
      <div className="table-responsive mt-5">
        <div className="d-flex justify-content-between align-items-center m-4 px-2 py-2 rounded-4 border"
          style={{ backgroundColor: "#faf8f5" }}>
          <h4 className="mb-0 fs-2">Categories</h4>
          <div className="d-flex gap-2">
            <ReactToPrint
              trigger={() => (
                <button className="btn btn-primary rounded-3" onClick={handlePrint}>
                  Print Table
                </button>
              )}
              content={() => componentRef.current}
              onAfterPrint={() => setPrintView(false)}
              onBeforeGetContent={handleBeforeGetContent}
            />
            <button className="btn btn-primary rounded-3" onClick={openAddModal}>
              <AiOutlinePlus className="me-1" /> Add Category
            </button>
          </div>
        </div>

        <div className="px-4 mb-4">
          <div className="d-flex align-items-center justify-content-between gap-3 px-4 rounded-4 border"
            style={{ backgroundColor: "#faf8f5" }}>
            <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
            <ColumnToggle allColumns={allColumns} getToggleHideAllColumnsProps={getToggleHideAllColumnsProps} />
          </div>

          <div style={{ margin: printView ? "50px" : null }} ref={componentRef}>
            {printView && (
              <>
                <div style={{ padding: "1.5rem" }}><h2>Categories</h2></div>
                <div style={{ marginBottom: '1rem', textAlign: "right", fontSize: "1.5rem" }}>
                  Date: {new Date().toLocaleDateString()}
                </div>
              </>
            )}
            <div className="table-responsive rounded-4 overflow-hidden border mt-5"
              style={{ backgroundColor: "#ffffff" }}>
              <table
                className="table table-striped table-hover caption-top fs-4"
                {...getTableProps()}
                style={{ margin: 0 }}
              >
                <thead>
                  {headerGroups.map(headerGroup => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map(column => (
                        <th
                          className="px-4"
                          style={{ backgroundColor: "#ffffff" }}
                          {...column.getHeaderProps()}
                        >
                          {column.render('Header')}
                          {!printView && (
                            <div>{column.canFilter ? column.render('Filter') : null}</div>
                          )}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                  {page.map(row => {
                    prepareRow(row);
                    return (
                      <tr {...row.getRowProps()}>
                        {row.cells.map(cell => (
                          <td
                            className="px-4"
                            style={{ backgroundColor: "#ffffff" }}
                            {...cell.getCellProps()}
                          >
                            {cell.render('Cell')}
                          </td>
                        ))}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Pagination */}
        <div>
          <ul className="pagination justify-content-center pagination-lg fs-4">
            <span style={{ padding: "5px"}}>
              page{' '}
              <strong>
                <em style={{ color: 'blue' }}>{pageIndex + 1}</em> of {pageOptions.length}
              </strong>
            </span>
            <select
              className="form-select form-select-lg fs-4"
              style={{ maxWidth: '110px' }}
              value={pageSize}
              onChange={e => setPageSize(Number(e.target.value))}
            >
              {[10, 15, 20, 30, 40, 50, data.length].map((pageSize, index) => (
                <option key={index} value={pageSize}>
                  Show {pageSize}
                </option>
              ))}
            </select>
            <li>
              <button className="page-link" onClick={() => gotoPage(0)} disabled={!canPreviousPage}>{'<<'}</button>
            </li>
            <li className={`page-item ${!canPreviousPage ? 'disabled' : ''}`}>
              <button className="page-link" onClick={previousPage} disabled={!canPreviousPage}>Previous</button>
            </li>
            <li className={`page-item ${!canNextPage ? 'disabled' : ''}`}>
              <button className="page-link" onClick={nextPage} disabled={!canNextPage}>Next</button>
            </li>
            <li>
              <button className="page-link" onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>{'>>'}</button>
            </li>
          </ul>
        </div>
      </div>

    </div>
  );
};